import { Component, EventEmitter, Output } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-license-header',
  imports: [TranslateModule],
  templateUrl: './license-header.html',
  styleUrl: './license-header.scss',
})
export class LicenseHeader {
  @Output() readonly createRequested = new EventEmitter<void>();

  requestCreate(): void {
    this.createRequested.emit();
  }
}
